function Shimmer({ className = '' }: { className?: string }) {
  return (
    <div
      className={`animate-shimmer bg-gradient-to-r from-surface-800 via-surface-700 to-surface-800 bg-[length:200%_100%] rounded ${className}`}
    />
  );
}

function Hero() {
  return (
    <div className="w-full h-[70vh] bg-surface-900 animate-pulse">
      <div className="max-w-7xl mx-auto px-4 pt-40">
        <Shimmer className="h-8 w-64 mb-4" />
        <Shimmer className="h-12 w-96 mb-3" />
        <Shimmer className="h-4 w-32 mb-6" />
        <Shimmer className="h-16 w-full max-w-xl mb-6" />
        <div className="flex gap-3">
          <Shimmer className="h-12 w-36 rounded-lg" />
          <Shimmer className="h-12 w-36 rounded-lg" />
        </div>
      </div>
    </div>
  );
}

function Card() {
  return (
    <div className="flex-shrink-0 w-40 sm:w-48">
      <Shimmer className="w-full aspect-[2/3] rounded-lg mb-2" />
      <Shimmer className="h-4 w-3/4 mb-1" />
      <Shimmer className="h-3 w-1/2" />
    </div>
  );
}

function Row() {
  return (
    <div className="mb-8">
      <Shimmer className="h-6 w-48 mb-4" />
      <div className="flex gap-3 overflow-hidden">
        {Array.from({ length: 7 }).map((_, i) => (
          <Card key={i} />
        ))}
      </div>
    </div>
  );
}

function Grid({ count = 12 }: { count?: number }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i}>
          <Shimmer className="w-full aspect-[2/3] rounded-lg mb-2" />
          <Shimmer className="h-4 w-3/4 mb-1" />
          <Shimmer className="h-3 w-1/2" />
        </div>
      ))}
    </div>
  );
}

function Detail() {
  return (
    <div className="min-h-screen bg-surface-950">
      <div className="w-full h-[50vh] bg-surface-900 animate-pulse" />
      <div className="max-w-7xl mx-auto px-4 -mt-32 relative z-10">
        <div className="flex gap-6">
          <Shimmer className="w-48 md:w-64 aspect-[2/3] rounded-xl flex-shrink-0" />
          <div className="flex-1 pt-4">
            <Shimmer className="h-8 w-96 mb-3" />
            <Shimmer className="h-4 w-48 mb-6" />
            <Shimmer className="h-20 w-full mb-6" />
            <div className="flex gap-3">
              <Shimmer className="h-10 w-32 rounded-lg" />
              <Shimmer className="h-10 w-10 rounded-lg" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const Skeleton = { Hero, Card, Row, Grid, Detail };

export default Skeleton;
